import restClient from '../restClient';
export const GET_COUNTRIES = 'GET_COUNTRIES';
export const FETCHING_COUNTRIES = 'FETCHING_COUNTRIES';
export const GET_COUNTRIES_FAILED = 'GET_COUNTRIES_FAILED';
export const COUNTRIES_CONFIRMED = 'COUNTRIES_CONFIRMED';
export const CONFIRM_COUNTRIES_FAILED = 'COUNTRIES_CONFIRMED_FAILED';
const doGetCountries = countries => ({
  countries,
  type: GET_COUNTRIES
});
const countriesConfirmed = response => ({
  response,
  type: COUNTRIES_CONFIRMED
});
const failedToConfirmCountries = error => ({
  error,
  type: CONFIRM_COUNTRIES_FAILED
});
const fetchingCountries = () => ({
  type: FETCHING_COUNTRIES
});
const failedToFetchCountries = error => ({
  error,
  type: GET_COUNTRIES_FAILED
});
export const getCountries = () => async dispatch => {
  try {
    dispatch(fetchingCountries());
    const countries = await restClient.countries();
    dispatch(doGetCountries(countries));
  } catch (error) {
    dispatch(failedToFetchCountries(error));
  }
};
export const confirmCountries = confirmCountryData => async dispatch => {
  try {
    const response = await restClient.confirmCountries(confirmCountryData);
    dispatch(countriesConfirmed(response));
  } catch (error) {
    dispatch(failedToConfirmCountries(error));
  }
};